import { defineStore } from "pinia";
import { ref } from "vue";
import { useIntervalFn } from "@vueuse/core";
import { GetDownloadsCount } from "@/services/downloads";
import { useAuthStore } from "@/stores/auth";

export const useDownloadsStore = defineStore("DownloadsStore", () => {
  const auth = useAuthStore();
  const processing = ref(0);
  const done = ref(0);
  const POLL_INTERVAL_MS = 20000;
  // При ошибке перехватчик ApiV1 показывает тост, а на 401 уводит на логин —
  // при периодическом опросе это повторялось бы бесконечно, поэтому после
  // серии неудач опрос останавливается сам.
  const MAX_FAILURES = 10;
  let failures = 0;

  const applyCounts = (data) => {
    processing.value = data?.processing ?? 0;
    done.value = data?.done ?? 0;
  };

  const fetchCount = async () => {
    if (!auth.userData) return;

    try {
      const response = await GetDownloadsCount();
      applyCounts(response?.data);
      failures = 0;
    } catch {
      failures += 1;
      if (failures >= MAX_FAILURES) {
        pause();
        console.warn("[downloads] опрос счётчика остановлен после ошибок");
      }
    }
  };

  const { pause, resume } = useIntervalFn(fetchCount, POLL_INTERVAL_MS, { immediate: false });

  const startCountTimer = () => {
    failures = 0;
    fetchCount();
    resume();
  };

  const stopCountTimer = () => {
    pause();
  };

  return {
    processing,
    done,
    fetchCount,
    startCountTimer,
    stopCountTimer,
  };
});
